import buttonClick from './src/index';
export default Vue => {
    Vue.component(buttonClick.name, buttonClick);
};